export class NightTimeAddress {
  public addressSecurityCd: number = null;
  public addressSecurityDescr: string = null;
  public suburbCd: string = null;
}
